import { useNavigate } from 'react-router'
import dayjs from 'dayjs'

import StarFilledIcon from '@ant-design/icons/StarFilled'

import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Stack from '@mui/material/Stack'
import IconButton from '@components/_mui/IconButton'
import Typography from '@components/_mui/Typography'

import useFlaggedHistory, { FlaggedHistoryType } from '@hooks/useFlaggedHistory'
import Avatar from '@components/Avatar'

export default function PagesHistoryFlaggedTab({ onClose }) {
  const { items, toggle } = useFlaggedHistory()

  const isEmpty = items.length === 0

  if (isEmpty) {
    return (
      <Box sx={{ p: 2 }} data-testid="flagged-empty">
        <Typography variant="h5" align="center" sx={{ color: 'text.secondary', height: 50, fontWeight: 'normal' }}>
          Nothing to see here!
        </Typography>
      </Box>
    )
  }

  return (
    <Box sx={{ maxHeight: '400px', overflowY: 'auto' }}>
      <List disablePadding data-testid="flagged-list">
        {items.map((item, index) => (
          <FlaggedItem
            key={item.id}
            divider={index < items.length - 1}
            item={item}
            onToggle={() => toggle(item.type, item.data)}
            onClose={onClose}
          />
        ))}
      </List>
    </Box>
  )
}

function FlaggedItem({ item, divider = false, onToggle, onClose }) {
  const navigate = useNavigate()

  if (item.type === FlaggedHistoryType.Patient) {
    const testId = `flagged-patient-item-${item.data.fullName}`

    return (
      <>
        <ListItemButton
          divider={divider}
          data-testid={testId}
          onClick={() => {
            navigate(`/app/patients/${item.data.id}`)
            onClose()
          }}
        >
          <ListItemIcon>
            <Avatar user={item.data} size="lg" />
          </ListItemIcon>
          <ListItemText
            disableTypography
            primary={
              <Typography noWrap data-testid={`${testId}-name`} sx={{ lineHeight: 1 }}>
                {item.data.fullName}
              </Typography>
            }
            secondary={
              <Stack spacing={-0.5}>
                <Typography component="span" variant="body2" data-testid={`${testId}-id`} sx={{ color: 'text.secondary' }}>
                  Patient {item.data.id}
                </Typography>
                <Typography variant="caption" data-testid={`${testId}-date`} sx={{ color: 'text.secondary' }}>
                  {dayjs(item.createdAt).format('MMM D, hh:mm A')}
                </Typography>
              </Stack>
            }
            sx={{ pl: 1, my: 0 }}
          />
          <IconButton
            color="warning"
            data-testid="flag-button"
            onClick={(e) => {
              e.stopPropagation()
              onToggle()
            }}
          >
            <StarFilledIcon />
          </IconButton>
        </ListItemButton>
      </>
    )
  }
}
